import { AppToast } from 'common/components/AppToast';
import { Toaster } from 'react-hot-toast';

export const AppToaster: React.FC = () => (
  <Toaster
    position="bottom-left"
    gutter={8}
    containerStyle={{ zIndex: 1000001 }}
    toastOptions={{
      duration: 4000,
      error: { duration: 6000 },
      loading: { duration: 60_000 },
    }}
  >
    {(toast) => <AppToast toast={toast} />}
  </Toaster>
);
